// ============================================================
// CardDownloadApp.js — Card fixo de download do aplicativo (Android)
//
// Aparece para qualquer usuário logado (atleta, técnico, coordenação).
// Pelo celular, o botão baixa o APK direto; pelo PC, o QR code leva ao
// download no aparelho. Dispensável com "×" (reaparece no próximo login,
// pois o estado é só em memória — não persiste).
//
// O link é FIXO (Firebase Storage). Se um dia o APK mudar de local,
// basta atualizar LINK_APP aqui e regerar o QR (qrApp.js).
// ============================================================

import { useState } from "react";
import { AZUL, BRANCO } from "../tema";
import { QR_APP_DATA_URI } from "./qrApp";
import useIsMobile from "../useIsMobile";

export const LINK_APP = "https://firebasestorage.googleapis.com/v0/b/revelar-frequencia-3194e.firebasestorage.app/o/downloads%2Fapprevelartalentos.apk?alt=media&token=69e2553e-fa3a-4e02-adb7-3ab966afd8a4";

export default function CardDownloadApp() {
  const isMobile = useIsMobile();
  const [fechado, setFechado] = useState(false);
  if (fechado) return null;

  return (
    <div style={{
      position: "relative",
      background: "linear-gradient(135deg, #0C2340 0%, #123A63 100%)",
      borderRadius: 14,
      padding: isMobile ? "16px 16px 18px" : "18px 22px",
      marginBottom: 20,
      color: BRANCO,
      display: "flex",
      alignItems: "center",
      gap: isMobile ? 14 : 22,
      flexDirection: isMobile ? "column" : "row",
      textAlign: isMobile ? "center" : "left",
      overflow: "hidden",
    }}>
      <button
        onClick={() => setFechado(true)}
        aria-label="Fechar"
        title="Fechar"
        style={{ position: "absolute", top: 8, right: 10, background: "rgba(255,255,255,0.15)", border: "none", color: BRANCO, width: 26, height: 26, borderRadius: 20, cursor: "pointer", fontSize: 15, lineHeight: 1, display: "flex", alignItems: "center", justifyContent: "center" }}
      >×</button>

      {/* QR — só faz sentido no PC (escanear com o celular). No mobile fica oculto. */}
      {!isMobile && (
        <div style={{ background: BRANCO, borderRadius: 10, padding: 8, flexShrink: 0, lineHeight: 0 }}>
          <img src={QR_APP_DATA_URI} alt="QR code para baixar o app" width={104} height={104} style={{ display: "block" }} />
        </div>
      )}

      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 16, fontWeight: 800, marginBottom: 3 }}>📱 Baixar o aplicativo</div>
        <div style={{ fontSize: 13, opacity: 0.85, lineHeight: 1.5, marginBottom: 12 }}>
          {isMobile
            ? "Toque no botão para instalar o app no seu celular (Android) e registrar sua presença nos treinos."
            : "Escaneie o QR code com a câmera do celular (Android) para instalar o app, ou baixe pelo botão."}
        </div>
        <a
          href={LINK_APP}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: "inline-flex", alignItems: "center", gap: 8, background: BRANCO, color: AZUL, fontWeight: 700, fontSize: 14, textDecoration: "none", padding: "10px 20px", borderRadius: 9 }}
        >
          ⬇️ Baixar agora (Android)
        </a>
        <div style={{ fontSize: 11, opacity: 0.7, marginTop: 8 }}>
          Após baixar, abra o arquivo e permita a instalação de apps do navegador, se solicitado.
        </div>
      </div>
    </div>
  );
}
